import { marketingService } from './marketing.instance';
import {
  parsePromotedContestsCollection,
  type PromotedContestCarousel,
  type PromotedContestsCollectionSlug,
} from './promoted-contests.schema';

export const getPromotedContestsCollection = async (
  slug: PromotedContestsCollectionSlug,
  signal?: AbortSignal
): Promise<PromotedContestCarousel[]> => {
  const response = await marketingService.get<unknown>(`/promoted-contests/collections/${slug}`, {
    signal,
  });
  return parsePromotedContestsCollection(response.data);
};
